export default "__VITE_ASSET__CabXS1iH__"